import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import ProfilesPage from 'pages/Profiles/Profiles'
import ProfileCreationPage from 'pages/Profiles/ProfileCreate'
import ProfilePreview from 'pages/Profiles/ProfilePreview'
import ProfileEditPage from 'pages/Profiles/ProfileEdit'
import BadgeAssignPage from 'pages/Profiles/BadgeAssign'
import RecommenderPage from 'pages/Profiles/RecommenderPage' // <-- NEW: Import the page
import { base_url } from 'env'
import ProfileSurveyCreatePage from 'pages/Profiles/SurveyCreate'
import ProfileSurveyEditPage from 'pages/Profiles/SurveyEdit'

export const ProfileRoutes: RouteObject[] = [
  {
    path: 'profiles',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/profile/?includeArchived=true')
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <ProfilesPage />,
  },
  {
    path: '/profile',
    element: <ProfileCreationPage />,
  },
  {
    path: '/profile/:id',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/profile/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <ProfilePreview />,
  },
  {
    path: '/profile/:id/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/profile/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <ProfileEditPage />,
  },
  {
    path: '/profile/:profileId/badge/assign',
    element: <BadgeAssignPage />,
  },
  {
    path: '/profile/:profileId/recommender',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(
          `${base_url}/profile/${params.profileId}`
        )
        return response.data
      } catch (error) {
        console.error('Failed to load profile for recommender test:', error)
        return redirect('/profiles')
      }
    },
    element: <RecommenderPage />,
  },
  {
    path: '/profile/:profileId/survey/create',
    element: <ProfileSurveyCreatePage />,
  },
  {
    path: '/profile/:profileId/survey/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(
          `${base_url}/profile/${params.profileId}/survey`
        )
        return response.data
      } catch (error) {
        console.error('Failed to load profile survey for editing:', error)
        return redirect(`/profile/${params.profileId}`)
      }
    },
    element: <ProfileSurveyEditPage />,
  },
]
